import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Box } from "@mantine/core";
import { useParams } from "react-router-dom";

import { ErrorView, PageTitle } from "@components/shared";
import { SurveyForm } from "@components/Survey";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

import { List } from "@legacy/Survey/Versions";

import { survey as dummySurvey } from "@dummy/survey";

export default function SurveyDetail() {
  const [error, setError] = useState(null);
  const [survey, setSurvey] = useState(null);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios
      .get(`/surveys/${id}/`)
      .then(({ data }) => {
        setSurvey(data.response[0]);
      })
      .catch((err) => {
        // setError(err);
        setSurvey(dummySurvey);
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!survey) return null;

  return (
    <div>
      <PageTitle
        title={`${survey.name}`}
        subtitle={`${survey.variety_formatted}`}
        icon={entityIcon.survey()}
        iconColor={entityColor.survey}
      />
      <Card mt="md">
        <SurveyForm
          id={id}
          name={survey.name}
          survey={survey}
          onSuccess={fetchData}
        />
      </Card>
      <Card mt="md">
        <List surveyId={id} surveyVariety={survey.variety} />
      </Card>
    </div>
  );
}
